<template>
    <div>   
        <!-- delete dialog declaered here to use it as ref -->
        <delete-dialog ref="DeleteDialog" @on-delete="needToRestShownItems = true; filter()">
            <p class="mb-0 text-body-1">
                {{$t('are-you-sure-you-want-to')}} <span class="red--text">{{$t('delete')}}</span> {{$t('the-visit') + $t('?')}}
            </p>
        </delete-dialog>

        <!-- visit details dialog -->
        <v-dialog
            v-model="dialog"
            transition="dialog-transition"
            max-width="1000"
            persistent
            @keydown.esc="dialog = false"
        >
            <!-- dialog content -->
            <v-card>
                <div class="d-flex justify-end background-title-card white--text">
                    <v-card-title
                        class="d-flex w-100 justify-center py-1 d-flex"
                    >
                        {{ $t('Visits.visit-details') }}
                    </v-card-title>
                    <v-btn icon @click="dialog = false; visitId = null; view = false" class="me-2">
                        <v-icon color="white" > mdi-close-circle-outline </v-icon>
                    </v-btn>
                </div>
                <v-card-text class="pb-0 pt-1 px-3">
                    <v-row class="pt-2">
                        <v-col cols="3" align-self="center" class="pb-0">
                            <v-autocomplete 
                                v-model="dataReadDialog.employeeId"
                                :label="$t('inputs.employees')"
                                :items="medicalRepsBrief"
                                item-text="name"
                                item-value="id"
                                outlined
                                dense
                                hide-details
                                readonly
                            />
                        </v-col>

                        <v-col cols="3" align-self="center" class="pb-0">
                            <v-text-field 
                                v-model="dataReadDialog.date"
                                :label="$t('inputs.date')"
                                outlined
                                dense
                                hide-details
                                readonly
                            />
                        </v-col>

                        <v-col cols="3" align-self="center" class="pb-0">
                            <v-autocomplete 
                                v-model="dataReadDialog.specialty"
                                :label="$t('inputs.specialty')"
                                :items="specialties"
                                item-text="name"
                                item-value="id"
                                multiple
                                outlined
                                dense
                                hide-details
                                readonly
                            />
                        </v-col>

                        <v-col cols="3" align-self="center" class="pb-0">
                            <v-autocomplete 
                                v-model="dataReadDialog.classification"
                                :items="classification"
                                item-text="name"
                                item-value="id"
                                :label="$t('inputs.class')"
                                outlined
                                dense
                                hide-details
                                readonly
                            />
                        </v-col>

                        <v-col cols="3" align-self="center" class="pb-0">
                            <v-text-field 
                                v-model="dataReadDialog.customer"
                                :label="$t('inputs.customer')"
                                outlined
                                dense
                                hide-details
                                readonly
                            />
                        </v-col>

                        <v-col cols="3" align-self="center" class="pb-0">
                            <v-text-field
                                v-model="dataReadDialog.city"
                                :label="$t('inputs.city')"
                                outlined
                                dense
                                hide-details
                                readonly
                            />
                        </v-col>

                        <v-col cols="3" align-self="center" class="pb-0">
                            <v-text-field 
                                v-model="dataReadDialog.region"
                                :label="!managementHierarchyRegions ? $t('inputs.region') : $t('inputs.area')"
                                outlined
                                dense
                                hide-details
                                readonly
                            />
                        </v-col>

                        <v-col cols="6" align-self="start" class="">
                            <!-- dialog content -->
                            <div class="ms-1 mt-1">
                                <!-- samples table -->
                                <p class="text-body-2 font-weight-bold my-1 mb-2">
                                    {{ $t('Visits.distributed-materials') }}
                                </p>
                                <bee-handy-smart-table
                                    v-model="sampleTableInputs"
                                    ref="sampleTable"
                                    :items="entriesSamples"
                                    :headers="headerSamples"
                                    zebra
                                    dense
                                    height="430px"
                                    pagination-on-scroll
                                    :show-add-row="!view"
                                    :editable-rows="!loading || !view"
                                    @keypress.enter="isEditSample ? editSamples() : addSamples()"
                                    hide-inputs-details
                                    hide-default-footer
                                    :data-table-props="{
                                        disableSort: true
                                    }"
                                    :shown-rows-text="$t('shown-rows')"
                                    resizable="vertically"
                                    resizers-height="400px"
                                    class="mt-2"
                                >
                                    <!-- product name -->
                                    <template v-slot:input.materialId="{ on, attr }">
                                        <v-autocomplete
                                            :items="materials"
                                            item-value="id"
                                            item-text="name"
                                            v-on="on"
                                            v-bind="attr"
                                        ></v-autocomplete>
                                    </template>

                                    <template v-slot:no-input.actions>
                                        <div class="d-flex justify-center">
                                            <tooltip text="Add" top>
                                                <v-btn
                                                    icon
                                                    small
                                                    color="success"
                                                    :disabled="loading"
                                                    @click="isEditSample ? editSamples() : addSamples()"
                                                >
                                                    <v-icon>
                                                        mdi-check-circle-outline
                                                    </v-icon>
                                                </v-btn>
                                            </tooltip>
                                        </div>
								    </template>
                        
                                    <!-- action column -->
                                    <template v-slot:item.actions="{ item, index }">
                                        <div class="d-flex">
                                            <tooltip :text="$t('edit-doctor')" top>
                                                <v-btn
                                                    icon
                                                    small
                                                    color="edit-color"
                                                    :disabled="loading"
                                                    @click="() => {
                                                        $refs.sampleTable.activeEditForRow(index);
                                                        editAddressRowIndex = index;
                                                        isEditSample = true;
                                                        $refs.sampleTable.resetInputsFocus()
                                                    }"
                                                >
                                                    <v-icon>
                                                        mdi-pencil
                                                    </v-icon>
                                                </v-btn>
                                            </tooltip>
                                            
                                            <tooltip :text="$t('delete-doctor')" top>
                                                <v-btn
                                                    icon
                                                    small
                                                    @click="deleteSamplesRow({ id: item.id, index })"
                                                    color="alert-color"
                                                >
                                                    <v-icon>
                                                        mdi-delete
                                                    </v-icon>
                                                </v-btn>
                                            </tooltip>
                                        </div>
                                    </template>
                                </bee-handy-smart-table>
                            </div>

                            <v-row class="mt-2">
                                <!-- other samples table -->
                                <v-col cols="8">
                                    <v-text-field
                                        v-model="otherSamples"
                                        class="mb-1"
                                        :label="$t('inputs.other-samples')"
                                        dense
                                        outlined
                                        hide-details
                                        :readonly="view"
                                    >
                                    </v-text-field>
                                </v-col>

                                <v-divider vertical class="my-1" />

                                <!-- durationInMinutes-->
                                <v-col cols="4">
                                    <v-text-field
                                        v-model="durationInMinutes"
                                        class="mb-1"
                                        :label="$t('inputs.duration-in-minutes')"
                                        dense
                                        outlined
                                        hide-details
                                        :readonly="view"
                                    >
                                    </v-text-field>
                                </v-col>
                            </v-row>
                        </v-col>

                        <v-col cols="6">
                            <v-row class="mt-1">
                                <!-- residant doctor names -->
                                <v-col cols="12">
                                    <v-text-field
                                        v-model="residantDoctorNames" 
                                        dense
                                        hide-details
                                        outlined
                                        :label="$t('inputs.residant-doctor-names')"
                                    ></v-text-field>
                                </v-col>
                                <!-- coreMessage -->
                                <v-col cols="12">
                                    <v-textarea
                                        v-model="coreMessage"
                                        class="mb-1"
                                        :label="$t('inputs.core-message')"
                                        dense
                                        outlined
                                        hide-details
                                        :readonly="view"
                                        rows="1"
                                        :auto-grow="true"
                                    />
                                </v-col>
                                
                                <v-divider vertical class="my-1" />

                                <!-- Notes -->
                                <v-col cols="12">
                                    <v-textarea
                                        v-model="notes"
                                        class="mb-1"
                                        :label="$t('inputs.notes')"
                                        dense
                                        outlined
                                        hide-details
                                        :readonly="view"
                                        rows="1"
                                        :auto-grow="true"
                                    />
                                </v-col>
                                <v-divider vertical class="my-1" />

                                <!-- Objections-->
                                <v-col cols="12">
                                    <v-textarea
                                        v-model="objections"
                                        class="mb-1"
                                        :label="$t('inputs.objections')"
                                        dense
                                        outlined
                                        hide-details
                                        :readonly="view"
                                        rows="1"
                                        :auto-grow="true"
                                    />
                                </v-col>

                                <!-- notes -->
                                <v-col cols="12" >
                                    <v-textarea
                                        v-model="nextCall"
                                        class="mb-1"
                                        :label="$t('inputs.next-call')"
                                        dense
                                        outlined
                                        hide-details
                                        :readonly="view"
                                        rows="1"
                                        :auto-grow="true"
                                    />
                                </v-col>
                            </v-row>

                            <!-- Unavailable octo Products -->
                            <div
                                v-if="visitsConfig?.UnavailableMaterials"
                                class="mt-4"
                            >
                                <v-autocomplete
                                    v-model="unavailablesMaterials"
                                    :items="materials"
                                    item-value="id"
                                    item-text="name"
                                    dense
                                    outlined
                                    hide-details
                                    label="Unavailable Products"
                                    multiple
                                    :readonly="view"
                                />
                            </div>

                            <!-- competitive samples  -->
                            <div
                               v-if="visitsConfig?.CompetetiveSample"
                                class="my-3"
                            >
                                <v-textarea
                                    v-model="competitiveSamples"
                                    label="Competitors"
                                    outlined
                                    dense
                                    hide-details
                                    rows="1"
                                    :auto-grow="true"
                                />
                            </div>

                            <!-- center notes -->
                            <div v-if="visitsConfig?.NextVisitNotes">
                                <v-text-field
                                    v-model="centerNotes"
                                    class="mb-1"
                                    label="Center notes"
                                    dense
                                    outlined
                                    hide-details
                                >
                                </v-text-field>
                            </div>
                        </v-col>
                    </v-row>

                </v-card-text>
                <v-card-actions class="justify-end">
                    <v-btn
                    	v-if="!view"
                    	text
                    	color="success"
                    	@click="update()"
                        :loading="submitLoading"
                    >
                        {{$t('save')}}
                    </v-btn>
                    <!-- dialog active button -->
                    <v-btn text @click="dialog = false; visitId = null; view = false" :disabled="submitLoading">
                        {{$t('close')}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-row>
			<v-col>
				<!-- tabs -->
				<v-tabs
					v-model="tab"
					class="d-flex flex-column white--text"
					show-arrows
					slider-color="primary"
                    background-color="#8080801c"
					@change="needToRestShownItems = true; clearFilter(); getEntityForType(); filter()"
				>
					<v-tab
						v-for="title in customersTypes.map(c => c.name)"
						:key="title"
						class="text-capitalize"
						:disabled="loading" 
					>
						{{ title }}
					</v-tab>
				</v-tabs>
        		<v-divider class="mx-1" />
			</v-col>

            <v-col align-self="end" class="d-flex" 
				:class="{
					'justify-end': $vuetify.breakpoint.mdAndUp,
					'justify-start': $vuetify.breakpoint.smAndDown
				}"
			>
				<div class="d-flex justify-space-between align-center">            
            		<div class="d-flex">
						<v-btn
							:to="{ name: 'visited-doctors' }"
							small
							color="light-blue white--text"
							class="text-center mx-2"
							elevation="0"
						>
							{{$t('Visits.visits-count')}}
						</v-btn>

                		<!-- View chart -->
						<v-btn
                            v-if="isSuperAdmin || permissionsUser.Charts === roleName.action"
							small
							color="light-blue white--text"
							:to="{ name: 'statistics-chart', params: { type: 'visits' } }"
						>
							<v-icon small class="me-2">mdi-chart-bar</v-icon>
                            {{$t('Visits.view-chart')}}
						</v-btn>

                        <v-btn
							small
							color="light-blue white--text mx-2"
							:to="{ name: 'unavailable-material-in-visits-statistics' }"
						>
							<v-icon small class="me-2">mdi-chart-bar</v-icon>
                            {{$t('Visits.unavailable-material-from-visit')}}
						</v-btn>

                        <v-divider v-if="excelFile" vertical class="mx-1" />

                        <v-btn
                            v-if="excelFile"
                        	small
                        	color="green lighten-1 white--text"
                        	@click="ImportExcel"
                        	class="mx-1"
                        	:loading="loadingExcel"
                        	:disabled="loadingExcel"
                        >
                            <v-icon> mdi-file-table-outline </v-icon>
                            {{$t('export-excel')}}
                        </v-btn>
            		</div>
        		</div>
            </v-col>
        </v-row>

        <!-- filter -->
        <v-form @submit.prevent="isFiltered = true; needToRestShownItems = true; filter();">
            <v-row class="align-center ma-1 mt-2">
                <!-- sectors -->
                <v-col v-if="0" md="3" cols="12" class="pa-1 d-flex">
                    <v-autocomplete
                        v-model="sectorId"
                        :items="sectorsMine"
                        item-text="name"
                        item-value="id"
                        :label="managementHierarchyRegions ? 'Regions' : 'Areas'"
                        dense
                        clearable
                        hide-details
                        :loading="regionsLoading"
                        :disabled="loading || regionsLoading || cityId === []"
                        @click:clear="cityId = []; regionIds = []; fetchAllCities()"
                        @change="getCitiesFilter()"
                        outlined
                    >
                    </v-autocomplete>
                </v-col>

                <!-- city region filter -->
                <v-col lg="4" md="5" sm="8" cols="12" class="pa-1">
                    <v-row class="justify-space-between ma-0">
                        <!-- city name -->
                        <v-col
                        	md="5"
                        	sm="4"
                        	cols="6"
                        	class="pa-0"
                            :class="{ 
                                'pe-1': $i18n.locale === 'en',
                                'ps-1': $i18n.locale === 'ar'
                            }"
                        >
                            <v-autocomplete
                                v-model="cityId"
                                :items="cities"
                                item-text="name"
                                item-value="id"
                                :label="$t('inputs.city')"
                                dense
                                prepend-icon="mdi-map-marker-multiple"
                                hide-details
                                append-icon
                                multiple
                                clearable
                                :disabled="loading"
                                :search-input.sync="searchCityId"
                                @change="setRegions(); searchCityId = null"
                                outlined
                            >
                                <!-- @change="fetchRegionsDueCity; searchCityId = null" -->
                                <template v-slot:prepend-item>
                                    <v-list-item
                                        ripple
                                        @click="toggleCities"
                                    >
                                        <v-list-item-action>
                                            <v-icon>
                                                {{ iconCities }}
                                            </v-icon>
                                        </v-list-item-action>
                                        
                                        <v-list-item-content>
                                            <v-list-item-title>
                                                {{ $t('select-all') }}
                                            </v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                    <v-divider class="mt-2"></v-divider>
                                </template>

                                <template v-slot:selection="{ item, index }">
                                    <span v-if="index === 0" class="me-1">{{ item.name }}</span>
                                    <span
                                        v-if="index === 1"
                                        class="grey--text text-caption"
                                    >
                                        (+{{ cityId.length - 1 }})
                                    </span>
                                </template>
                            </v-autocomplete>
                        </v-col>
            
                        <!-- region -->
                        <v-col md="7" sm="8" cols="6" class="pa-0">
                            <v-autocomplete
                                v-model="regionIds"
                                :items="regionsAll.filter(c => cityId.includes(c.cityId)).sort(function(a, b) { if(a.name < b.name) {return -1}; if(a.name > b.name) { return 1 }; return 0 })"
                                item-text="name"
                                item-value="id"
                                :label="!managementHierarchyRegions ? $t('inputs.region') : $t('inputs.area')"
                                dense
                                multiple
                                clearable
                                hide-details
                                append-icon
                                :loading="regionsLoading"
                                :disabled="loading || regionsLoading || cityId === []"
                                outlined
                                :search-input.sync="searchRegion"
                                append-outer-icon="mdi-select-search"
                                @click:append-outer="getMedical()"
                            >
                             <!-- customerType !== null ? getEntityForType(customerType) : null -->
                                <template v-slot:selection="{ item, index }">
                                    <span v-if="index === 0" class="me-1">{{ item.name }}</span>
                                    <span
                                        v-if="index === 1"
                                        class="grey--text text-caption"
                                    >
                                        (+{{ regionIds.length - 1 }})
                                    </span>
                                </template>

                                <template v-slot:prepend-item>
                                    <v-list-item ripple @click="toggle">
                                        <v-list-item-action>
                                            <v-icon>
                                                {{ icon }}
                                            </v-icon>
                                        </v-list-item-action>
                                        
                                        <v-list-item-content>
                                            <v-list-item-title>
                                                {{ $t('select-all') }}
                                            </v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                    <v-divider class="mt-2"></v-divider>
                                </template>
                            </v-autocomplete>
                        </v-col>
                    </v-row>
                </v-col>
            
                <v-divider vertical class="my-3 mx-1 grey"/>

                <v-col cols="auto" class="pa-0">
                    <v-radio-group
                        v-model.number="dateType"
                        row
                        class="mt-1"
                        hide-details
                        :disabled="loading"
                    >
                        <v-radio
                            :label="$t('daily-date')"
                            :value="1"
                        ></v-radio>
                        <v-radio
                            :label="$t('from-date') + ' / ' + $t('to-date')"
                            :value="2"
                        ></v-radio>
                    </v-radio-group>
                </v-col>

                <v-col v-if="dateType === 2" cols="6" sm="3" md="2" class="pa-1">
                    <bee-date-picker
                        v-model="startDate"
                        :input-label="$t('inputs.start-date')"
                        menu-picker
                        dense
                        hide-details
                        :input-props="{
                            outlined: true,
                            dense: true,
                            clearable: true
                        }"
                        :allowed-dates="disableDates"
                        :disabled="loading"
                    ></bee-date-picker>
                </v-col>

                <!-- end date -->
                <v-col v-if="dateType === 2" cols="6" sm="3" md="2" class="pa-1">
                    <bee-date-picker
                        v-model="endDate"
                        :input-label="$t('inputs.end-date')"
                        menu-picker
                        dense
                        hide-details
                        :input-props="{
                            outlined: true,
                            dense: true,
                            clearable: true
                        }"
                        :allowed-dates="disableDates"
                        :disabled="loading"
                    ></bee-date-picker>
                </v-col>
                <!-- filter -->
                <v-col v-if="dateType === 1" cols="12" sm="6" md="3" class="pa-1">
                    <bee-date-input
                        v-model="date"
                        :append-icon="$i18n.locale === 'en' ? 'mdi-menu-right' : 'mdi-menu-left' "
                        :prepend-icon="$i18n.locale === 'en' ? 'mdi-menu-left' : 'mdi-menu-right' "
                        :label="$t('inputs.date')"
                        input-format-order="DD-MM-YYYY"
                        dense
                        :loading="loading"
                        :disabled="loading"
                        hide-details
                        @click:append="
                            needToRestShownItems = true;
                            addDate();
                            filter()
                        "
                        @click:prepend="
                            needToRestShownItems = true;
                            subDate();
                            filter()
                        "
                    ></bee-date-input>
                </v-col>
            
                <v-divider vertical class="my-3 grey"/>
            
                <!-- specialty -->
                <v-col
                    v-if="visitsConfig?.specialtyId"
                    md="2"
                    sm="4"
                    cols="6"
                    class="pa-1"
                >
                    <v-autocomplete
                        v-model="specialtyId"
                        :items="specialties"
                        item-text="name"
                        item-value="id"
                        :label="$t('inputs.specialty')"
                        dense
                        clearable
                        hide-details
                        :loading="filterLoading"
                        :disabled="loading"
                        outlined
                    ></v-autocomplete>
                </v-col>
            
                <!-- classification -->
                <v-col md="2" sm="4" cols="6" class="pa-1">
                    <v-autocomplete
                        class="classification"
                        v-model="workload"
                        :items="classification"
                        item-value="id"
                        item-text="name"
                        :label="$t('inputs.class')"
                        dense
                        clearable
                        hide-details
                        :disabled="loading"
                        outlined
                    ></v-autocomplete>
                </v-col>
                
                <v-divider vertical class="my-2 grey"/>
            
                <!-- medical rep name -->
                <v-col md="3" sm="4" cols="12" class="pa-1 d-flex align-start">
                    <v-autocomplete
                        v-model="medicalRepIds"
                        :items="regionIds.length === 0 ? medicalRepsBrief.filter(c => c.employeeType === userType.medicalRep) : medicalRepsForRegion.filter(c => c.employeeType === userType.medicalRep)"
                        item-text="name"
                        item-value="id"
                        :label="$t('inputs.medical-rep')"
                        prepend-icon="mdi-account-tie"
                        hide-details
                        clearable
                        :loading="filterLoading || loadingMedicalForRegion"
                        :disabled="loading"
                        outlined
                        dense
                        multiple
                    >
                        <template v-slot:selection="{ item, index }">
                            <span v-if="index === 0" class="me-1">{{ item.name }}</span>
                            <span
                                v-if="index === 1"
                                class="grey--text text-caption"
                            >
                                (+{{ medicalRepIds.length - 1 }})
                            </span>
                        </template>
                    </v-autocomplete>
                </v-col>
                <!-- customer type 'will appear just for all tap (tab=3)' -->
                <!-- <v-col md="2" sm="4" cols="12" class="pa-1" v-if="tab === 3">
                    <v-autocomplete
                        v-model="customerType"
                        :items="customersTypes"
                        item-text="name"
                        item-value="id"
                        :label="$t('inputs.customer-type')"
                        dense
                        clearable
                        hide-details
                        :loading="filterLoading"
                        :disabled="loading"
                        outlined
                        @change="customerType !== null ? getEntityForType(customerType) : null"
                    ></v-autocomplete>
                </v-col> -->
                <!-- name of all -->
                <v-col v-if="0" md="3" sm="4" cols="12" class="pa-1 d-flex align-start">
                    <v-autocomplete
                        v-model="entityId"
                        :items="selections.entities"
                        item-text="name"
                        item-value="id"
                        prepend-icon="mdi-doctor"
                        dense
                        hide-details
                        clearable
                        :loading="entityLoading"
                        :label="selections.label[tab]"
                        :disabled="loading || entityLoading || (tab === 0 && customerType === null)"
                        outlined
                    >
                        <!-- :multiple="isDoctor" -->

                        <template v-slot:selection="data">
                            <span
                                v-if="data.index === 0"
                            >                            
                                {{'  ' + data.item.name + '  ' }}
                            </span>

                            <span
                                v-if="data.index === 1"
                            >
                                (+{{ entityId.length - 1 }})
                            </span>
                        </template>
                    </v-autocomplete>
                </v-col>

                <v-divider vertical class="my-3 grey"/>

                <v-col class="d-flex pa-1">
                    <v-btn-toggle
                        v-model="sort"
                        mandatory
                        dense
                        class="mb-1"
                        color="primary"
                        @change="isFiltered = true; needToRestShownItems = true; filter()"
                        :dir="$i18n.locale === 'en' ? 'ltr' : 'rtl' "
                    >
                        <v-btn :disabled="loading">{{$t('Visits.sort-by-classification')}}</v-btn>
                        <v-btn :disabled="loading">{{$t('Visits.sort-by-name')}}</v-btn>
                    </v-btn-toggle>
                </v-col>
            
                <v-spacer />
            
                <!-- search button -->
                <v-col cols="auto" class="pa-1">
                    <v-btn
                        color="success"
                        class="px-sm-4 mx-2"
                        :loading="loading"
                        :disabled="loading || isAllFieldsEmpty"
                        small
                        type="submit"
                    >
                        <v-icon class="me-1"> mdi-magnify </v-icon>
                        {{$t('search')}}
                    </v-btn>
            
                    <v-btn
                        class="px-sm-8"
                        @click="needToRestShownItems = true; clearFilter(); filter()"
                        :disabled="(!isFiltered || loading) && !$route.query.visitId"
                        color="alert-color white--text"
                        small
                    >
                        {{ $t('reset') }}
                    </v-btn>

                    <v-divider vertical class="mx-2" style="height: 24px"/>
                    <!-- Back to -->
                    <v-btn
                        small
                        :to="{ 
                            name: 'visits-group-by-medical-rep', 
                            query: {
                                date: $route.query.date,
                                endDate: $route.query.endDate ? $route.query.endDate : null 
                            } 
                        }"
                        color="grey white--text"
                        :disabled="loading"
                    >
                        <v-icon small class="me-1"> mdi-arrow-left-circle </v-icon>
                        {{$t('back')}}
                    </v-btn>
                </v-col>
            </v-row>
        </v-form>
 
        <bee-handy-table 
            ref="table"
            :headers="headers"
            :items="[]"
            fixed-header
            :height="$vuetify.breakpoint.height - 235"
            :data-table-props="{
                disableSort: true
            }"
            :loading="loading"
            dense
            zebra
            pagination-on-scroll
            :pagination-on-scroll-auto-reset-shown="false"
            pagination-on-scroll-server-items
            :items-per-page="20"
            :scroll-options.sync="scrollOptions"
            :server-items-length="serverItemsLength"
            @pagination-on-scroll:reach-last-row="filter"
            :shown-rows-text="$t('shown-rows')"
        >           
            <!-- specialty -->
            <template v-slot:item.specialty="{ item }">
                {{ item.entitySpecialtyId.length === 0 ? 
                    item.entitySpecialtyName[0] : 
                    item.entitySpecialtyId.map(c => getSpecialtyById(c).name).join(', ') 
                }}
            </template>
            <!-- actions -->
			<template v-slot:item.action="{ item }">
                <!-- activate button -->
                <tooltip :text="$t('Visits.view-visit')" top>
                    <v-btn
                        icon
                        small
                        color="success"
                        :loading="visitId === item.id && view"
                        :disabled="loading || Boolean($route.query.preview)"
                        @click="view = true; visitId = item.id; fetchVisitData(customersTypes.map(c => c.id)[tab], item.id, item);"
                    >
                        <v-icon >mdi-eye</v-icon>
                    </v-btn>
                </tooltip>

                <tooltip :text="$t('edit-visit')" top>
                    <v-btn
                        icon
                        small
                        color="edit-color"
                        :loading="visitId === item.id && !view"
                        :disabled="loading || Boolean($route.query.preview)"
                        @click="visitId = item.id; fetchVisitData(customersTypes.map(c => c.id)[tab], item.id, item);"
                    >
                        <v-icon >mdi-pencil</v-icon>
                    </v-btn>
                </tooltip>

                <tooltip :text="$t('delete')" top>
                    <v-btn
                        icon
                        small
                        color="red lighten-1"
                        :disabled="loading || Boolean($route.query.preview)"
                        @click="$refs.DeleteDialog.activeDeleteDialog(item.id, 'visits')"
                    >
                        <v-icon>mdi-delete</v-icon>
                    </v-btn>
                </tooltip>

                <tooltip :text="$t('print')" top>
                    <v-menu offset-y>
                        <template v-slot:activator="{ attr, on }">
                            <v-btn
                                small
                                depressed
                                v-on="on"
                                v-bind="attr"
                                @click="invoiceId = item.id"
                                color="transparent"
                                :loading="loading && invoiceId === item.id"
                                :disabled="loading"
                                icon
                            >
                                <v-icon color="primary">mdi-printer</v-icon>
                            </v-btn>
                        </template>

                        <v-list dense>
                            <v-list-item @click="invoiceId = item.id, printReport(invoiceId, true)">
                                <v-list-item-title>
                                    {{ $t('invoices.office-invoice') }}
                                </v-list-item-title>
                            </v-list-item>
                            <v-list-item @click="invoiceId = item.id, printReport(invoiceId, false)">
                                <v-list-item-title>
                                    {{ $t('invoices.pos-invoice') }}
                                </v-list-item-title>
                            </v-list-item>
                        </v-list>
				    </v-menu>
                </tooltip>
			</template>
        </bee-handy-table>
    </div>
</template>

<script>
import Tooltip from '@/components/Tooltip'
import DeleteDialog from '@/components/DeleteDialog'
import { mapState, mapGetters } from 'vuex'
import rules from '@/validation rules'
import { roleName, userType, fieldsVisits } from '@/helpers/enums'
import { dig, findClassification, downloadBlob, disableDates } from '@/helpers/functions'
import moment from 'moment'
import { excelFile, managementHierarchyRegions, isDisabledFriday, enableVacations, enableCustomerType } from '@/configs/global.config'

export default {
    name: 'Visits',

    components:{
        Tooltip,
        DeleteDialog
    },

    // watch: {
    //     date(val) {
    //         if (val) {
    //             this.filter()
    //         }
    //     }
    // },

    data(){
        return {
            fieldsVisits,
            isDoctor: false,
            excelFile,
            submitLoading: false,
            dateType: 1,
            view: false,
            date: null,
            sectorId: null,
            entriesSamples: [],
            materialsEmployee: [],
            isEditSample: false,
            sampleTableInputs: {},
            editAddressRowIndex: null,
            createdAtForVisit: null,
            entityIForRow: null,
            dialog: false,
            searchCityId: null,
            searchRegion: null,
            roleName,
            userType,
            loadingExcel: false,
            tab:0,
            
            // filter data
            medicalRepIds: [],
            cityId: [],
            regionIds: [],
            entityId: [],
            workload:null,
            specialtyId:null,
            startDate: this.moment().startOf('month').format('YYYY-MM-DD'),
            endDate: this.moment().endOf('month').format('YYYY-MM-DD'),
            customerType: null,

            // entity name
            selections:{
                label: [this.$t('inputs.customer'), this.$t('inputs.doctor'), this.$t('inputs.pharmacy'), this.$t('inputs.center')],
                entities: [],
            },

            // pagination props
            options: {},
            totalVisits: null,

            // helpers 
            visitId: null,
            loading: false,
            filterLoading: false,
            entityLoading: false,
            regionsLoading: false,
            isFiltered: false,

            // visit dialog
            samples: [],
            otherSamples: null,
            notes: null,
            objections: null,
            coreMessage: null,
            durationInMinutes: null,
            nextCall: null,
            unavailablesMaterials: [],
            competitiveSamples: [],
            centerNotes: null,
            residantDoctorNames: null,

            // pagination
            needToRestShownItems: false,
            scrollOptions: {},
            serverItemsLength: 0,

            rules,
            sort: 1,
            loadingMedicalForRegion: false,
            medicalRepsForRegion: [],
            dataReadDialog: {
                employeeId: null,
                date: null,
                specialty: null,
                classification: null,
                customer: null,
                city: null,
                region: null
            },
            managementHierarchyRegions,
            isDisabledFriday,
            enableVacations,
            enableCustomerType,
            showMenu: false,
            invoiceId: null
        }
    },

    computed:{
        ...mapState({
            visits: state => state.visits.visits,
            visitsFiltered: state => state.visits.visitsFiltered,
            cities: state => state.cities.cities,
            materials: state => state.materials.materials,
            regions: state => state.regions.regions,
            regionsAll: state => state.regions.regionsAll,
            medicalRepsBrief: state => state.medicalreps.medicalRepsBrief,
            specialties: state => state.specialties.specialties,
            classification: state => state.workload.classification,
            permissionsUser: state => state.auth.youPermissions,
            isSuperAdmin: state => state.auth.isSuperAdmin,
            sectorsMine: state => state.sectors.sectorsMine,
            vacationsDayDetails: state => state.vacations.vacationsDayDetails,
            customersTypes: state => state.entityType.customersTypes,
            visitsConfig: state => state.configuration.configurations.visitsConfig
        }),

        ...mapGetters({
            getMedicalRepById: 'medicalreps/getMedicalRepById',
            getSpecialtyById: 'specialties/getSpecialtyById',
            getRegionAllById: 'regions/getRegionAllById',
            getCityById: 'cities/getCityById',
            getMaterialById: 'materials/getMaterialById',
            getEntityById: 'entities/getEntityById',
            getVisitById: 'visits/getVisitById',
            getCityByName: 'cities/getCityByName',
            getRegionAllByName: 'regions/getRegionAllByName',
            getSupervisorById: 'supervisors/getSupervisorById',
            getClassificationById: 'workload/getClassificationById',
        }),
        
        isAllFieldsEmpty(){
            return (
                !this.medicalRepIds && this.regionIds.length === 0 && !this.entityId && !this.startDate && !this.endDate && this.customerType === null && !this.specialtyId && this.workload === null 
            )
        },
        
        selectedAllRegions () {
            return this.regionIds.length === this.regionsAll.filter(c => this.cityId?.includes(c.cityId)).length;
        },

        icon() {
            if (this.selectedAllRegions) return 'mdi-close-box'
            return 'mdi-checkbox-blank-outline'
        },

        headers(){
            const headers = [
                { 
                    text: this.$t('headers.employee-name'),
                    value: 'employeeId',
                    setValueExpr: val => this.getMedicalRepById(val)?.name,
                    class: 'primary--text',
                    cellClass: 'primary--text',
                    align: 'start',
                },
                {
                    text: this.$t('headers.date'), 
                    value: 'createdAt', 
                    type: 'date',
                    dateFormat: 'YYYY-MM-DD',
                    align: 'start',  
                    cellClass:'text-caption', 
                    columnClass: 'font-sm',
                },
                { 
                    text: this.customersTypes.find(c => c.id === this.customersTypes[this.tab]?.id)?.name,
                    value: 'entityName',
                    align: 'start',
                    class:'text-capitalize text-body-2 font-weight-bold',
                },
                {
                    text: this.$t('headers.amount-received'),
                    value: 'amountReceived',
                    name: 'amount-received',
                    type: 'number',
                    align: 'start',
                },
                { 
                    text: this.$t('headers.city'), 
                    value: 'entityCityName', 
                    align: 'start',
                },
                { 
                    text: !managementHierarchyRegions ? this.$t('headers.region') : this.$t('headers.area'), 
                    value: 'entityRegionName', 
                    align: 'start',
                },
                { 
                    text: this.$t('headers.notes'), 
                    value: 'notes', 
                    align: 'center', 
                    noNotAvailableText: true
                },
                {
                    text:  this.$t('headers.core-message'),
                    value: 'coreMessage',
                    align: 'center'
                },
                { 
                    text: this.$t('headers.objection'), 
                    value: 'objections', 
                    setValueExpr: val => val ? val.length > 20 ? val.slice(0, 20) + '...' : val : '-',
                    align: 'start', 
                    noNotAvailableText: true
                },
                { 
                    text: this.$t('headers.next-call'), 
                    value: 'purpose', 
                    setValueExpr: val => val ? val.length > 20 ? val.slice(0, 20) + '...' : val : '-',
                    align: 'start',
                    noNotAvailableText: true
                },
                { 
                    text: '', 
                    name: 'action', 
                    value: 'action',
                    align: 'center', 
                    width: '10%'
                },
            ];

            if (this.tab !== 1) {
                headers.splice(2, 0,
                    {
                        text: this.$t('headers.specialty'), 
                        value: 'entitySpecialtyName',
                        name: 'specialty',
                        // setValueExpr: val => val.map(c => this.dig('getSpecialtyById', c, 'name')).join(', '),
                        // setValueExpr: (val, item) => item,
                        align: 'start',
                        noNotAvailableText: true
                    },
                    { 
                        text: this.$t('headers.class'), 
                        value: 'entityWorkload', 
                        setValueExpr: val => this.getClassificationById(val)?.name || '-',
                        align: 'start'
                    }
                )
            } else {
                headers.splice(headers.length - 1, 0, {
                    text: this.$t('headers.unavailable-products'),
                    value: 'unavailableRamaProductsCount',
                    align: 'start',
                })
            }
            
            const sharedClass = 'text-body-2 font-weight-bold px-2';

            for (let i = 0; i < headers.length; i++) {
                headers[i].class = headers[i].class ? headers[i].class + ' ' + sharedClass : sharedClass;                
                headers[i].cellClass = headers[i].cellClass ? headers[i].cellClass + ' px-2' : 'px-2';                
            }

            return headers;
        },

        headerUnAvailableSamples () {
            return [
                {
                    text: this.$t('headers.name'),
                    name: 'name',
                    value: 'material',
                    setValueExpr: val => this.getMaterialById(val)?.name
                }
            ]
        },

        headerSamples() {
            const headers = [
                {
                    text: this.$t('headers.samples'),
                    name: 'materialId',
                    value: 'materialId',
                    setValueExpr: val => this.getMaterialById(val)?.name
                },
                {
                    text: this.$t('headers.quantity'),
                    name: 'amount',
                    value: 'amount',
                    type: 'number'
                }
            ];
            if (!this.view) {
                headers.push({
                    text: '',
                    name: 'actions',
                    value: 'actions',
                    noInput: true
                })
            } 
            return headers
        },

        selectedAllCities () {
            return this.cityId.length === this.cities.length;
        },
        iconCities () {
            if (this.selectedAllCities) return 'mdi-close-box'
            return 'mdi-checkbox-blank-outline'
        }
    },

    methods: {
        deleteSamplesRow(rowData) {
            this.$refs.sampleTable.resetEdit();
			this.isEditSample = false;
			this.entriesSamples.splice(rowData.index, 1);

            for (let i = 0; i < this.entriesSamples.length; i++) {
                if (this.entriesSamples[i].id > rowData.id) {
                    this.entriesSamples[i].id--;
                }
            }
			
			this.$nextTick(() => {
				this.$refs.sampleTableInputs.resetInputs();
				this.$refs.sampleTableInputs.resetInputsFocus()
			})
		},
        
        delete() {
            this.loading = true
            this.$store.dispatch('visits/deleteVisit', { id: this.visitId }).then(() => {
                this.filter()
            }).finally(() => {
                this.loading = false
            })
        },

        editSamples() {
            if (this.$refs.sampleTable.validate()) {
                this.entriesSamples[this.editAddressRowIndex].materialId = this.sampleTableInputs.materialId
                this.entriesSamples[this.editAddressRowIndex].amount = this.sampleTableInputs.amount
                
                this.$refs.sampleTable.resetEdit();
                this.isEditSample = false;
                this.$nextTick(() => {
                    this.$refs.sampleTable.resetInputs();
					this.$refs.sampleTable.resetInputsFocus()
                })
			} 
        },

        addSamples() {
            if (this.$refs.sampleTable.validate()) {
                const itemInTable = this.entriesSamples.find(c => c.materialId === this.sampleTableInputs.materialId);
                if (itemInTable) {
                    itemInTable.amount = itemInTable.amount + 1
                } else {
                    this.entriesSamples.push({
                        ...this.sampleTableInputs,
                    })
                    this.entriesSamples.map((c, index) => ({ ...c, id: index }))
                }
                this.$refs.sampleTable.resetInputs();
                this.$refs.sampleTable.resetInputsFocus();
            }
        },
        ImportExcel() {
            this.loadingExcel = true
            this.$store.dispatch('exporter/fetchVisitsExport', { 
                FromDate: this.startDate, 
                ToDate: this.endDate, 
                // EntityType: this.tab === 1 || this.tab === 2 ? this.tab : this.tab === 3 ? 0 : null,
                entityTypeId: this.customersTypes[this.tab]?.id,
                RegionIds: this.regionIds,
                EmployeeId: this.medicalRepIds,
                SpecialtyId: this.specialtyId,
                Workload: this.workload,
                OrderByWorkLoad: this.sort,
                OrderByName: this.sort
            }).finally(() => {
                this.loadingExcel = false
            })
        },
        // helpers
        dig,
        findClassification,
        disableDates,
        moment,

        update() {
            this.needToRestShownItems = true
            this.submitLoading = true
            this.$store.dispatch('visits/updateVisit', {
                id: this.visitId,
                entityId: this.entityIForRow, 
                otherSamples: this.otherSamples, 
                objections: this.objections,
                nextVisitNotes: this.centerNotes,
                purpose: this.nextCall, 
                materialAmounts: this.entriesSamples.map(c => ({ materialId: c.materialId, amount: c.amount })),
                unavailableMaterialIds: this.unavailablesMaterials, 
                competitiveSamples: [this.competitiveSamples], 
                createdAt: this.createdAtForVisit,
                coreMessage: this.coreMessage, 
                durationInMinutes: +this.durationInMinutes,
                notes: this.notes,
                residentDoctorNames: this.residantDoctorNames
           }).then(() => {
                this.filter()
                this.dialog = false
                this.view = false
           }).finally(() => {
                this.visitId = null
                this.submitLoading = false
           })
        },

        // Find data functions 
        fetchVisitData(type, visitId){
            this.$store.dispatch('visits/fetchByFilter', { visitId: visitId, page: 1, PerPage: 20, regionIds: [], employeeIds: [], entityIds: [] })
            .then((data) => {
                const item = data.data[0]
                this.entriesSamples = item.materialAmounts?.map((c, index) => ({ ...c, id: index }));
                this.otherSamples = item.otherSamples;
                this.notes = item.notes;
                this.objections = item.objections;
                this.nextCall = item.purpose;
                this.coreMessage = item.coreMessage;
                this.durationInMinutes = item.durationInMinutes;

                this.unavailablesMaterials = item.unavailableMaterialIds;
                this.competitiveSamples = item.competitiveSamples?.join(', ');
                this.centerNotes = null;
                this.residantDoctorNames = item.residantDoctorNames
                
                this.dialog = true;
                this.entityIForRow = item.entityId
                this.createdAtForVisit = item.createdAt
                
                this.dataReadDialog.employeeId = item.employeeId
                this.dataReadDialog.date = moment(item.createdAt).format('YYYY-MM-DD')
                this.dataReadDialog.specialty = item.entitySpecialtyId
                this.dataReadDialog.classification = item.entityWorkload
                this.dataReadDialog.customer = item.entityName
                this.dataReadDialog.city = item.entityCityName
                this.dataReadDialog.region = item.entityRegionName
                this.centerNotes = item.nextVisitNotes ? item.nextVisitNotes : '';
          
                this.$store.dispatch('materialTransactions/fetchRemaining', { id: item.employeeId }).then((data) => {
                    this.materialsEmployee = data
                })
            })
        },

        fetchRegionsDueCity(){
            this.entityId = [];
            this.selections.entities = [];
            this.regionIds = [];
            if (!this.cityId) return;

            this.regionIds = [];
            this.regionsAll.forEach(region => {
                if (this.cityId.includes(region.cityId)) {
                    this.regionIds.push(region?.id);
                }
            });

            this.selections.entities = [];
            if (this.regionIds.length === 0) return;

            this.entityLoading = true;
            this.getEntityForType()
        },

        setRegions () {
            this.regionIds = [];
            if (!this.cityId) return;
            this.regionsAll.forEach(region => {
                if (this.cityId.includes(region.cityId)) {
                    this.regionIds.push(region?.id);
                }
            });
            if (this.regionIds.length) {
                this.loadingMedicalForRegion = true
                this.$store.dispatch('medicalreps/fetchAllBrief', { regionIds: this.regionIds }).then((data) => {
                    this.medicalRepsForRegion = data
                }).finally(() => {
                    this.loadingMedicalForRegion = false
                })
            }
        },

        fetchEntitiesDueRegion(){
            // this.selections.entities = [];
            // if (this.regionIds.length === 0) return;

            this.entityLoading = true;
            // this.$store.dispatch('entities/fetchAllBrief', {
            //     type: this.entityTypeForCurrentTab,
            //     regionIds: []
            // })
            // .then((response) => {
            //     this.selections.entities = response.data;
            // })
            // .finally(() => {
            //     this.entityLoading = false
            // })
            // this.searchRegion = null
            // this.loadingMedicalForRegion = true
        },
        getMedical() {
            if (this.regionIds.length) {
                this.loadingMedicalForRegion = true
                this.medicalRepIds = []
                this.$store.dispatch('medicalreps/fetchAllBrief', { regionIds: this.regionIds }).then((data) => {
                    this.medicalRepsForRegion = data
                }).finally(() => {
                    this.loadingMedicalForRegion = false
                })
            }
        },
        
        filter(newOptionsScroll, isFirstLoad = false) {
            console.log(';isFirstLoad', isFirstLoad)
            if (isFirstLoad === false && this.$route.query.visitId) {
                this.$router.replace({
                    query: null
                })
            }
            this.loading = true;
            let page = 1;

            if (newOptionsScroll) {
                page = newOptionsScroll.page;
            }

            const { itemsPerPage } = this.scrollOptions;
            return this.$store.dispatch('visits/fetchByFilter', {
                fromDate: this.dateType === 1 ? this.date : this.startDate, 
                toDate: this.dateType === 1 ? this.date : this.endDate,
                /*
                    next line is testing 'customerType' !== null that's mean filter -of all tab- don't apply so entityType belongs to current tab by 'entityTypeForCurrentTab'
                */
                // entityType: this.customerType !== null ? this.customerType : this.entityTypeForCurrentTab,
                // typeId: this.customerType,
                entityTypeId: this.customersTypes[this.tab]?.id,
                regionIds: this.regionIds,
                employeeIds: this.medicalRepIds,
                // entityName: this.entityId,

                // changing just for doctor
                // entityIds: this.entityId.length !== 0 ? this.customerType === entityType.doctor ? this.entityId : [this.entityId] : [],
                // entityIds: [this.entityId],
                specialtyId: this.specialtyId, 
                workload: this.workload,
                page: page,
                PerPage: itemsPerPage || 20,
                OrderByName: this.sort === 0,
                OrderByWorkLoad: this.sort === 1,
                IsMedicalRep: true,
                visitId: this.$route.query.visitId ? this.$route.query.visitId : null
            })
            .then(({ data, total }) => {
                if (this.needToRestShownItems) {
                    this.$refs.table.resetShownRows();
                    this.needToRestShownItems = false;
                }
                this.totalVisits = total;
                this.$refs.table.addScrollItems(data);
                this.serverItemsLength = this.totalVisits;

                if (this.$route.query.visitId) {
                    this.entriesSamples = data[0].materialAmounts?.map((c, index) => ({ ...c, id: index }));
                    this.otherSamples = data[0].otherSamples;
                    this.notes = data[0].notes;
                    this.objections = data[0].objections;
                    this.nextCall = data[0].purpose;
                    this.coreMessage = data[0].coreMessage;
                    this.durationInMinutes = data[0].durationInMinutes;

                    this.unavailablesMaterials = data[0].unavailableMaterialIds;
                    this.competitiveSamples = data[0].competitiveSamples?.join(', ');
                    this.centerNotes = null;
                    
                    this.dialog = true;
                    this.entityIForRow = data[0].entityId
                    this.createdAtForVisit = data[0].createdAt
                    
                    this.dataReadDialog.employeeId = data[0].employeeId
                    this.dataReadDialog.date = moment(data[0].createdAt).format('YYYY-MM-DD')
                    this.dataReadDialog.specialty = data[0].entitySpecialtyId
                    this.dataReadDialog.classification = data[0].entityWorkload
                    this.dataReadDialog.customer = data[0].entityName
                    this.dataReadDialog.city = data[0].entityCityName
                    this.dataReadDialog.region = data[0].entityRegionName
                    this.centerNotes = data.data[0]?.nextVisitNotes;

                    this.$store.dispatch('materialTransactions/fetchRemaining', { id: data.data[0].employeeId }).then((data) => {
                        this.materialsEmployee = data
                    })
                }
            })
            .finally(() => {
                if (!isFirstLoad) this.loading = false;
            })
        },

        clearFilter(){
            // clear fields
            this.medicalRepIds = [];
            this.cityId = [];
            this.regionIds = [];
            this.entityId = [];
            this.startDate = this.moment().format('YYYY-MM-DD');
            this.endDate = this.moment().format('YYYY-MM-DD');
            this.customerType = null;
            this.specialtyId = null;
            this.workload = null
            this.visit = null;
            this.$router.replace({
                query: {}
            })

            // reset total visites
            this.totalVisits = null;

            this.isFiltered = false
        },

        toggle () {
            this.$nextTick(() => {
                if (this.selectedAllRegions) {
                    this.regionIds = []
                } 
                else {
                    this.regionIds = []
                    this.regionIds = this.regionsAll.filter(c => this.cityId.includes(c.cityId)).map(c => c?.id);
                }
            })
        },

        // select all inputs
        toggleCities () {
            this.$nextTick(() => {
                if (this.selectedAllCities) {
                    this.cityId = []
                    this.regionIds = []
                } 
                else {
                    this.cityId = this.cities.map(c => c.id);
                    this.fetchRegionsDueCity()
                }
            })
        },

        getEntityForType(type) {
            this.entityId = []
            // if (type === entityType.doctor) {
            //     this.isDoctor = true
            // } else {
            //     this.isDoctor = false
            // }
            this.entityLoading = true;
            this.$store.dispatch('entities/fetchAllBrief', { 
                // type: this.entityTypeForCurrentTab === null ? type : this.entityTypeForCurrentTab,
                typeId: this.customersTypes[this.tab]?.id,
                regionIds: this.regionIds,
                preventStoreEntities: true
            }).then((data) => {
                this.selections.entities = data;
             }).finally(() => {
                this.entityLoading = false
            })
        },

        getCitiesFilter() {
            if (this.sectorId !== null) {
                this.loading = true;
                this.$store.dispatch('sectors/fetchCitiesInSector', { id: this.sectorId }).finally(() => {
                    this.loading = false
                })
            }
        },

        fetchAllCities() {
            this.sectorId = null
            this.loading = true
            this.$store.dispatch('cities/fetchCityMine', {}).finally(() => {
                this.loading = false
            })
        },

        addDate () {
            this.date = moment(this.date).add(1, 'day').format('YYYY-MM-DD');
            if (
                (this.moment(this.date).format('dddd') === 'Friday' && this.isDisabledFriday) ||
                (this.enableVacations && this.vacationsDayDetails.includes(this.date))
            ) {
                this.addDate()
            }
            return this.date
        },

        subDate() {
            this.date = moment(this.date).subtract(1, 'day').format('YYYY-MM-DD')
            if (
                (this.moment(this.date).format('dddd') === 'Friday' && this.isDisabledFriday) || 
                (this.enableVacations && this.vacationsDayDetails.includes(this.date))
            ) {
                this.subDate()
            }
            return this.date
        },

        printReport (id, isPosDevice) {
            this.loading = true
            this.$store.dispatch('exporter/printReport', { 
                visitId: id,
                posDevice: isPosDevice
            }).finally(() => {
                this.loading = false
            })
        }
    },

    created() {
        this.loading = true;
        this.filterLoading = true;
        if (!this.$route.query.visitId) {
            this.date = moment().format('YYYY-MM-DD')
        }
        if (this.$route.query.date && this.$route.query.endDate === null) {
            this.date = this.$route.query.date
        } else if (this.$route.query.date && this.$route.query.endDate) {
            this.startDate = this.$route.query.date
            this.endDate = this.$route.query.endDate
        }

        Promise.all([
            !this.classification.length ? this.$requestStack.setRequest({
                key: 'workload/fetchAll',
                promise: this.$store.dispatch('workload/fetchAll'),
            }) : this.$requestStack.getRequest('workload/fetchAll').promise,

            !this.cities.length ? this.$store.dispatch('cities/fetchCityMine', {}) : null,
            !this.regionsAll.length ? this.$store.dispatch('regions/fetchAllRegions', {}) : null,

            !this.materials.length ? this.$requestStack.setRequest({
                key: 'materials/fetchAll',
                promise: this.$store.dispatch('materials/fetchAll', true)
            }) : this.$requestStack.getRequest('materials/fetchAll').promise,

            !this.specialties.length ? this.$requestStack.setRequest({
                key: 'specialties/fetchAll',
                promise: this.$store.dispatch('specialties/fetchAll'),
            }) : this.$requestStack.getRequest('specialties/fetchAll').promise,
            
            !this.sectorsMine.length ? this.$store.dispatch('sectors/getSectorsMine') : null,
            enableVacations && !this.vacationsDayDetails.length ? this.$requestStack.setRequest({
                key: 'vacations/fetchAll',
                promise: this.$store.dispatch('vacations/fetchAll'),
            }) : this.$requestStack.getRequest('vacations/fetchAll').promise,
            
            enableCustomerType && !this.customersTypes.length ? this.$store.dispatch('entityType/fetchAll') : null,
            // this.getEntityForType(entityType.doctor),
            (async () => {
                if (!this.medicalRepsBrief.length) {
                    await this.$store.dispatch('medicalreps/fetchAllBrief', { nonDeleted: true });
                }
                if (this.$route.query.visitId) {
                    await this.filter(null, true);
                } else {
                    this.filter()
                }
            })()
        ]).finally(() => {
            this.loading = false;
            this.filterLoading = false;
        })
    },
    
    metaInfo: {
        title: 'Visits',
        titleTemplate: '%s | Octopharma'
    }
}
</script>

<style scoped>
.v-expansion-panel-content__wrap{
    padding: 0px 13px 0px;
}
#samples-table thead > tr > th{
    font-size: .9rem;
}
.font-sm {
    font-size: 9px;
}
.w-100 {
    width: 100%;
    margin-left: 1rem;
}
</style>
